import api from '@pray/shared/utils/api';
import type { PaginatedListResponse } from '@pray/shared/utils/api/types/response';

import type { TransactionResponse, TransactionsParams } from './types';

export async function getMemberTransactions(memberId: string, params: TransactionsParams = {}) {
  const url = `/web/studio/users/${memberId}/transactions`;

  const queryParams = {
    limit: params.limit ?? 50,
    offset: params.offset ?? 0,
    include_failed: params.includeFailed ? 'true' : 'false',
  };

  const response = await api.executeGetRequest<PaginatedListResponse<TransactionResponse>>(url, queryParams);

  return response.data;
}
